/**
 * AssetsIndustryMatrix — "View by Industry" swimlane as a CSS Grid so cards in the
 * SAME ROW across columns are aligned + equal-height (matches Figma). Columns =
 * industries; row 1 = headers; row r+2 = each column's r-th asset. Equal row height
 * comes from `grid-auto-rows: 1fr` + cards stretching to fill their cell. Columns
 * with fewer assets simply leave trailing cells empty.
 */
import type { IndustryColumn } from '../utils/assetGrouping';
import AssetCard from './AssetCard';

export default function AssetsIndustryMatrix({ columns }: { columns: IndustryColumn[] }) {
  if (columns.length === 0) {
    return <div className="ivt-assets-matrix__empty">没有符合条件的 Asset</div>;
  }
  const maxRows = Math.max(...columns.map((c) => c.assets.length));

  return (
    <div
      className="ivt-assets-matrix"
      style={{
        gridTemplateColumns: `repeat(${columns.length}, minmax(150px, 1fr))`,
        // Row 1 (headers) = auto height; the maxRows card rows share equal height.
        gridTemplateRows: `auto repeat(${maxRows}, 1fr)`,
      }}
    >
      {/* Row 1: column headers */}
      {columns.map((col, ci) => (
        <div
          className="ivt-assets-matrix__colhead"
          key={`h-${col.industry}`}
          style={{ gridColumn: ci + 1, gridRow: 1 }}
        >
          {col.industry} <span className="ivt-assets-matrix__count">({col.assets.length})</span>
        </div>
      ))}

      {/* Cards placed by (column, row); empty cells left blank so rows stay aligned. */}
      {columns.map((col, ci) =>
        col.assets.map((a, ri) => (
          <div
            className="ivt-assets-matrix__cell"
            key={a.assetId}
            style={{ gridColumn: ci + 1, gridRow: ri + 2 }}
          >
            <AssetCard asset={a} />
          </div>
        )),
      )}
    </div>
  );
}
